import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "@fontsource/poppins"; // Defaults to weight 400
import "@fontsource/poppins/400.css"; // Specify weight
import "@fontsource/poppins/400-italic.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <App />
  </> 
);

reportWebVitals();
